'use client';

import { motion } from 'framer-motion';
import CountUp from './CountUp';

const STATS = [
  { value: 4872, suffix: '', label: 'Images Delivered', sub: 'and counting' },
  { value: 99.3, decimals: 1, suffix: '%', label: 'On-Time Delivery', sub: 'within promised window' },
  { value: 12, suffix: 'h', label: 'Avg Turnaround', sub: 'as fast as 4 hours' },
  { value: 186, suffix: '', label: 'Projects Completed', sub: 'this month' },
];

const TRUST = ['Money-back guarantee', 'Human editors', '4–12 hour delivery', 'Revisions included', 'Secure uploads'];

export default function HomeStats() {
  return (
    <section className="relative py-16 lg:py-20 bg-[#0B0F1A] border-y border-white/[0.06]">
      <div className="max-w-7xl mx-auto px-6">
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center text-xs font-semibold text-purple-400 uppercase tracking-[0.2em] mb-10"
        >
          Trusted by real estate professionals worldwide
        </motion.p>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="rounded-2xl border border-white/[0.08] bg-white/[0.02] p-6 text-center hover:border-purple-500/30 transition-colors"
            >
              <div className="text-4xl lg:text-5xl font-bold bg-gradient-to-r from-purple-300 to-blue-400 bg-clip-text text-transparent tracking-tight">
                <CountUp end={s.value} decimals={s.decimals || 0} suffix={s.suffix} />
              </div>
              <div className="mt-2 text-sm font-semibold text-white">{s.label}</div>
              <div className="text-xs text-gray-500 mt-0.5">{s.sub}</div>
            </motion.div>
          ))}
        </div>

        {/* Trust badges */}
        <div className="mt-10 flex flex-wrap items-center justify-center gap-x-6 gap-y-3">
          {TRUST.map((t) => (
            <div key={t} className="flex items-center gap-2 text-sm text-gray-400">
              <svg className="w-4 h-4 text-emerald-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              {t}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
